// The full Communication Number Qualifier code list (DE 365) — shared by
// PER03, PER05 and PER07 across transaction sets. Transcribed from
// reference/session/00-envelope-and-common-qualifiers-txt.md.

import type {CodeListEntry} from './types';

export const COMMUNICATION_NUMBER_QUALIFIER_CODES: CodeListEntry[] = [
  {code: 'TE', label: 'Telephone'},
  {code: 'EX', label: 'Telephone Extension'},
  {code: 'FX', label: 'Facsimile'},
  {code: 'EM', label: 'Electronic Mail'},
  {code: 'CP', label: 'Cellular Phone'},
  {code: 'WP', label: 'Work Phone Number'},
  {code: 'UR', label: 'Uniform Resource Locator (URL)'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
